import { activeInstance } from '../instances'

// One tenant database → one Supabase project → one session (doc §8.3).
// The @omni/auth provider still exposes three app slots (mail/crm/pm); the
// shell feeds the SAME project into all three, which the provider collapses
// into a single client + single storage key + single magic link.
//
// Default creds are the EDNA CRM project (the same publishable fallback the
// surfaces ship standalone); override per deploy via VITE_SHELL_SUPABASE_*.
const url =
  import.meta.env.VITE_SHELL_SUPABASE_URL ??
  'https://aaheuncnheyqnuoyzokp.supabase.co'
const anonKey =
  import.meta.env.VITE_SHELL_SUPABASE_PUBLISHABLE_KEY ??
  'sb_publishable_fCEN0Qf1UfWHQ0CdSkt84w_osGT1heD'

export const shellProject = { url, anonKey }

/** The selected tenant instance (branding + modules). See src/instances/. */
export const instance = activeInstance

/** Product name for chrome + login. The fallback folds per build so a
 * single-tenant customer bundle carries no other product's name (MM always
 * sets copy.productName, so its fallback is unreachable either way). */
export const productName =
  instance.copy?.productName ??
  (import.meta.env.VITE_INSTANCE_SLUG === 'mortgage-man'
    ? 'Command Centre'
    : import.meta.env.VITE_INSTANCE_SLUG === 'ona-insurance-brokers'
      ? 'Command Center'
      : 'Omni Command')

// Kept for existing consumers (SurfaceHost, LoginScreen); now derived from
// the selected instance instead of the old `{ id: 'edna' }` hardcode.
export const workspace = {
  id: instance.slug,
  label: instance.displayName,
}
